<div class="dialog-form">
  <div class="group-detail-container">
    <section class="container-fluid no-breadcrumbs">

      <!-- Status do Processo -->
      <p-fieldset class="status-fieldset" *ngIf="processControlOrder">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-info-circle" style="margin-right: 8px;"></i>
            Status do Processo
          </h3>
        </p-header>
        <div class="status-cards">
          <div class="status-card">
            <div class="status-icon" [ngClass]="processControlOrder.conclusion ? 'concluded' : 'pending'">
              <i [class]="processControlOrder.conclusion ? 'pi pi-check-circle' : 'pi pi-clock'"></i>
            </div>
            <div class="status-content">
              <div class="status-label">Conclusão</div>
              <div class="status-value">
                {{ processControlOrder.conclusion ? 'Concluído' : 'Pendente' }}
              </div>
            </div>
          </div>
          <div class="status-card" *ngIf="processControlOrder.success !== null && processControlOrder.success !== undefined">
            <div class="status-icon" [ngClass]="processControlOrder.success ? 'success' : 'error'">
              <i [class]="processControlOrder.success ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
            </div>
            <div class="status-content">
              <div class="status-label">Sucesso</div>
              <div class="status-value">
                {{ processControlOrder.success ? 'Sucesso' : 'Erro' }}
              </div>
              <div *ngIf="!processControlOrder.success && getSqsMessageId() && getSqsMessageId() !== 'N/A'" class="error-actions" style="margin-top: 10px;">
                <button
                  pButton
                  type="button"
                  label="Visualizar Mensagem SQS"
                  icon="pi pi-eye"
                  class="p-button-sm p-button-outlined p-button-info"
                  (click)="viewSqsMessage()">
                </button>
              </div>
            </div>
          </div>
          <div class="status-card" *ngIf="processControlOrder.dateEnd">
            <div class="status-icon date">
              <i class="pi pi-calendar"></i>
            </div>
            <div class="status-content">
              <div class="status-label">Data de Término</div>
              <div class="status-value">
                {{ formatDate(processControlOrder.dateEnd) }}
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- Resumo do Grupo -->
      <p-fieldset class="group-info-fieldset" *ngIf="group">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-sitemap" style="margin-right: 8px;"></i>
            Informações do Grupo
          </h3>
        </p-header>
        <div class="group-info-content">
          <div class="info-row-single">
            <div class="info-item">
              <span class="info-label">SQS Message ID:</span>
              <span class="info-value sqs-id" *ngIf="group.sqsMessageId">{{ group.sqsMessageId }}</span>
              <span class="info-value" *ngIf="!group.sqsMessageId">N/A</span>
            </div>
            <div class="info-item">
              <span class="info-label">Pedidos:</span>
              <span class="info-value">
                <span class="badge" *ngFor="let orderId of group.orderIds; let i = index" [title]="'ID: ' + orderId">
                  {{ (group.orderNumbers && group.orderNumbers[i]) ? group.orderNumbers[i] : orderId }}
                </span>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Clientes:</span>
              <span class="info-value">
                <span class="badge" *ngFor="let customerId of group.customerIds; let i = index" [title]="'ID: ' + customerId">
                  {{ (group.customerNames && group.customerNames[i]) ? group.customerNames[i] : customerId }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- Invoices Geradas -->
      <p-fieldset class="invoices-fieldset" *ngIf="detailData && detailData.invoices && detailData.invoices.length > 0">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-file" style="margin-right: 8px;"></i>
            Faturas Geradas ({{ detailData.invoices.length }})
          </h3>
        </p-header>
        <div class="invoices-container">
          <div class="invoice-card" *ngFor="let invoice of detailData.invoices">
            <div class="invoice-header">
              <span class="invoice-number">Fatura #{{ invoice.invoiceNumber }}</span>
              <span class="invoice-status" [ngClass]="invoice.status?.toLowerCase()">
                {{ invoice.status }}
              </span>
            </div>
            <div class="invoice-content">
              <div class="invoice-item">
                <i class="pi pi-hashtag"></i>
                <span class="invoice-label">ID:</span>
                <span class="invoice-value">{{ invoice.id }}</span>
              </div>
              <div class="invoice-item">
                <i class="pi pi-dollar"></i>
                <span class="invoice-label">Valor:</span>
                <span class="invoice-value">R$ {{ invoice.value | number:'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- Log de Execução -->
      <p-fieldset class="log-fieldset" *ngIf="detailData && detailData.log && detailData.log.length > 0">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-list" style="margin-right: 8px;"></i>
            Log de Execução ({{ detailData.log.length }} ações)
          </h3>
        </p-header>
        <div class="log-container">
          <div class="log-timeline">
            <div class="log-item"
                 *ngFor="let action of detailData.log; let i = index"
                 [ngClass]="getActionClass(action.description)">
              <div class="log-marker">
                <i [class]="getActionIcon(action.description)"></i>
              </div>
              <div class="log-content">
                <div class="log-header">
                  <span class="log-description">{{ action.description }}</span>
                  <span class="log-time" *ngIf="i > 0">+{{ getTimeDifference(i) }}</span>
                </div>
                <div class="log-datetime">
                  <i class="pi pi-clock"></i>
                  {{ formatDateTime(action.datetime) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <!-- Loading -->
      <div *ngIf="loading" class="loading-container">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
        <p>Carregando detalhes do processo...</p>
      </div>

      <!-- Error -->
      <div *ngIf="error && !loading" class="error-container">
        <i class="pi pi-exclamation-triangle"></i>
        <p>{{ error }}</p>
      </div>

    </section>
  </div>
</div>
